import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import AppNotifications from '../../../AppNotifications';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import AppTooltip from '../../../AppTooltip';
import { alpha } from '@mui/material/styles';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import UserInfo from '../../components/UserInfo';
import HeaderNavWrapper from './HeaderNavWrapper';
import HorizontalNav from '../../components/HorizontalNav';
import './custom_styles.sass';
import './color_styles.css';
import { Badge, Button } from '@mui/material';
import { AiOutlineSwap } from 'react-icons/ai';
import { useAuthMethod, useAuthUser } from '@projectK/hooks/AuthHooks';
import { useNavigate } from 'react-router-dom';
import jwtAxios from '@projectK/services/auth/JWT';
import { useInterval } from '@projectK/hooks/useInterval';
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
import PersonOutlined from '@mui/icons-material/PersonOutlined';
import FacebookIcon from '@mui/icons-material/Facebook';
import XIcon from '@mui/icons-material/X';
import InstagramIcon from '@mui/icons-material/Instagram';
import BreadCrumbUi from '../../../../../../modules/src/lib/account/MyProfile/BreadCrumbUi/index.js';
import TopMenu from '../../../../../../modules/src/lib/account/MyProfile/TopMenu';
import { useInfoViewActionsContext } from '@projectK/context/InfoViewContextProvider';
import CompanyTheme from '@projectK/constants/CompanyTheme';
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';
import { useMobileSettings } from '@projectK/context/MobileContextProvider';
import {isSuperAdmin,isActualSuperAdmin} from '@projectK/context/RolesProvider';
import ServiceDeskWidget from '../../ServiceDeskWidget';
const canSwapTo = {
  developer: new Set([
    'owner',
    'super_admin',
    'admin',
    'coach',
    'instructor',
    'parent',
    'student',
    'participant',
    'under_18',
  ]),
  owner: new Set([
    'super_admin',
    'admin',
    'coach',
    'instructor',
    'parent',
    'student',
    'participant',
    'under_18',
  ]),
  super_admin: new Set([
    'owner',
    'super_admin',
    'admin',
    'coach',
    'instructor',
    'parent',
    'student',
    'participant',
    'under_18',
  ]),
  admin: new Set([
    'admin',
    'coach',
    'instructor',
    'parent',
    'student',
    'participant',
    'under_18',
  ]),
  coach: new Set(['parent', 'student', 'participant', 'under_18']),
  instructor: new Set(['parent', 'student', 'participant', 'under_18']),
  parent: new Set(['parent', 'student', 'participant', 'under_18']),
  student: new Set(['parent', 'student', 'participant', 'under_18']),
  participant: new Set(['parent', 'student', 'participant', 'under_18']),
  under_18: new Set([]),
};
const AppHeader = (props) => {
  const { isMobile } = useMobileSettings();
  const fullUrl = window.location.href;
  let parsedUrl = new URL(fullUrl);
  let path = parsedUrl.pathname;
  const { logout } = useAuthMethod();
  const { user } = useAuthUser();
  const {
    routesConfig,
    toggleNavCollapsed,
    tooltipPosition,
    fetchDataFunction,
    socialSettings,
    companyData,
  } = props;
  const navigate = useNavigate();
  const companyTheme = CompanyTheme();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [roleAnchorEl, setRoleAnchorEl] = React.useState(null);
  const infoViewActionsContext = useInfoViewActionsContext();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  useEffect(() => {
    if (fetchDataFunction) {
      getAllCartItems();
    }
  }, [fetchDataFunction]);

  const [notificationData, setNotificationData] = useState([]);
  const notifications = async () => {
    try {
      const response = await jwtAxios.get(`/notification`);
      const { data } = response;
      setNotificationData(data?.list);
    } catch (error) {
      console.error('Error fetching notifications', error);
    }
  };

  const [cartData, setCartData] = useState([]);
  const getAllCartItems = async () => {
    try {
      const response = await jwtAxios.get(`/cart`);
      const { data } = response;
      setCartData(data);
    } catch (error) {
      console.error('Error fetching cart items', error);
    }
  };
  const handleRoleOpenMenu = (event) => {
    setRoleAnchorEl(event.currentTarget);
  };

  const handleRoleCloseMenu = () => {
    setRoleAnchorEl(null);
  };

  useInterval(() => {
    user && notifications();
    getAllCartItems();
  }, 30000);

  /***********************Notification Mark all as Read********************* */

  const markAllRead = async (itemId) => {
    try {
      await jwtAxios.put(`/notification/user/${itemId}`);
      notifications();
    } catch (error) {
      useInfoViewActionsContext.fetchError(error.response.data.error);
    }
  };

  /***********************Switch settings********************* */

  const switchActualUserBack = async () => {
    try {
      // Make the POST request using jwtAxios
      await jwtAxios.post(`/admin/actual-user`, { isMobile: isMobile });

      window.location.reload();
    } catch (error) {
      // Handle the error here
      console.error(error);
    }
  };

  const switchBack = async (id, role, actualRole, actualUser, parentuser) => {
    try {
      // Make the POST request using jwtAxios
      await jwtAxios.post(`/admin/switch-user`, {
        selectedUserId: id,
        role,
        actualRole,
        actualUser,
        parentuser,
        isMobile,
      });

      window.location.reload();
    } catch (error) {
      // Handle the error here
      console.error(error);
      infoViewActionsContext.fetchError(error.response.data.error);
    }
  };
  const handleStopClick = (event) => {
    event.stopPropagation(); // Prevent the click event from bubbling up
  };

  function isAdmin(userData) {
    const isAdmin = isSuperAdmin(user) ||isActualSuperAdmin(user)
    return isAdmin;
  }

  const [isJSDLoaded, setIsJSDLoaded] = useState(false);

  useEffect(() => {
    const checkJSD = () => {
      let iframe = document.querySelector('#jsd-widget'); // Get the widget iframe
      if (iframe) {
        setIsJSDLoaded(true);
      } else {
        setTimeout(checkJSD, 500); // Keep checking every 500ms
      }
    };
    checkJSD();
  }, [isJSDLoaded]);

  return (
    <AppBar
      position='relative'
      color='inherit'
      sx={{
        boxShadow: 'none',
        borderBottom: (theme) => `solid 1px ${theme.palette.divider}`,
        backgroundColor: 'background.paper',
        width: {
          xs: '100%',
        },
      }}
      className='app-bar'
    >
      {/* <NotificationBar /> */}
      <Toolbar
        className={isMobile ? 'mobile-top-header' : 'top-header'}
        sx={{
          boxSizing: 'border-box',
          minHeight: { xs: 56, sm: 70 },
          px: { xs: 0 },
          borderBottom: (theme) => `solid 1px ${theme.palette.divider}`,
        }}
      >
        <Box
          sx={{
            boxSizing: 'border-box',
            width: '100%',
            maxWidth: { lg: 1140, xl: 1420 },
            mx: 'auto',
            px: 5,
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <Box sx={{ display: { xs: "none", lg: "block" } }}>
            {!isMobile && (
              <IconButton
                sx={{
                  marginRight: (theme) => theme.spacing(2),
                  color: 'text.secondary',
                }}
                edge='start'
                className='menu-btn'
                color='inherit'
                aria-label='open drawer'
                onClick={toggleNavCollapsed}
                size='large'
              >
                <MenuIcon
                  sx={{
                    width: 35,
                    height: 35,
                  }}
                />
              </IconButton>
            )}
          </Box>

          {isMobile ? (
            <Box sx={{ mr: 'auto' }} className='top-social'>
              <img
                src='/assets/images/MemberTraxxLogo-white.png'
                alt='Logo'
                style={{ height: '25px', width: 'auto' }}
              />
            </Box>
          ) : (
            <Box sx={{ mr: 'auto' }} className='top-social'>
              <Button size='small'>
                <FacebookIcon
                  onClick={() => {
                    window.open(socialSettings?.facebook, '_blank');
                  }}
                />
              </Button>
              <Button size='small'>
                <XIcon
                  onClick={() => {
                    window.open(socialSettings?.twitter, '_blank');
                  }}
                />
              </Button>
              <Button
                size='small'
                onClick={() => {
                  window.open(socialSettings?.slack, '_blank');
                }}
              >
                <img
                  src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAnElEQVR4nO2VUQrDIBAFPV6l97/A2ntMoQRi1mfdRCmldD4fuwz4TEzppwHuwAMoQO5lM4LCjvWyVQK27MCsINeS5YKO9JqgKk9RqpIbQah4f94CeyMYF39CUAZSCxXql4Cbm6uzZu7z4EoOfMmKeMkiMzUnCJUcvTGKYcmqvBduTnGuZL8dXpwRsLPkd31AZPb170EWxTfZnzTDE1NgIt9EsSxXAAAAAElFTkSuQmCC'
                  alt='slack-new'
                  style={{ width: '28px' }}
                />
              </Button>
              <Button size='small'>
                <InstagramIcon
                  onClick={() => {
                    window.open(socialSettings?.instagram, '_blank');
                  }}
                />
              </Button>
            </Box>
          )}
          <Box
            sx={{
              flexGrow: 1,
            }}
          />

          <Box
            sx={{
              ml: 4,
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <Box sx={{ display: { xs: "none", sm: "block" } }}>
              <Box
                sx={{
                  position: 'relative',
                  display: 'flex',
                  alignItems: 'center',
                  marginLeft: -2,
                  marginRight: -2,
                }}
              >
                {user?.actualUser ? (
                  <Box
                    sx={{
                      px: 1.85,
                    }}
                  >
                    <AppTooltip placement={tooltipPosition}>
                      <IconButton
                        className='icon-btn'
                        sx={{
                          borderRadius: '50%',
                          width: 40,
                          height: 40,
                          color: (theme) => theme.palette.text.secondary,
                          backgroundColor: (theme) =>
                            theme.palette.background.default,
                          border: 1,
                          borderColor: 'transparent',
                          transition: 'transform 0.3s ease-in-out',
                          '&:hover, &:focus': {
                            color: (theme) => theme.palette.text.primary,
                            backgroundColor: (theme) =>
                              alpha(theme.palette.background.default, 0.9),
                            borderColor: (theme) =>
                              alpha(theme.palette.text.secondary, 0.25),
                            transform: 'scale(1.1)',
                          },
                        }}
                        onClick={handleRoleOpenMenu}
                        size='large'
                      >
                        <AiOutlineSwap />
                      </IconButton>

                      <Menu
                        anchorEl={roleAnchorEl}
                        open={Boolean(roleAnchorEl)}
                        onClose={handleRoleCloseMenu}
                      >
                        {user?.selectedUserRoles?.map((role) => {
                          return user?.role[0] !== role?.role_name ? (
                            <MenuItem
                              sx={{ textTransform: 'capitalize' }}
                              key={role}
                            >
                              {canSwapTo[user?.actualRole[0]]?.has(
                                role.role_name,
                              ) ? (
                                <div //NOSONAR
                                  onClick={() => {
                                    // Check the condition before calling onSwitchRole
                                    const actualRole =
                                      user.actualRole[0] || user?.role[0];
                                    switchBack(
                                      user.id,
                                      role.role_name,
                                      actualRole,
                                      user.actualUser,
                                      null,
                                    );
                                  }}
                                >
                                  Swap to {role.role_name}
                                </div>
                              ) : (
                                <div
                                  className='disable-role'
                                  onClick={handleStopClick}
                                >
                                  {role.role_name}
                                </div>
                              )}
                            </MenuItem>
                          ) : null;
                        })}

                        {user?.parentuser && (
                          <MenuItem
                            sx={{ textTransform: 'capitalize' }}
                            onClick={() =>
                              switchBack(
                                user.parentuser,
                                'parent',
                                user.actualRole[0],
                                user.actualUser,
                                null,
                              )
                            }
                          >
                            Swap Back to Parent
                          </MenuItem>
                        )}

                        <MenuItem
                          sx={{ textTransform: 'capitalize' }}
                          onClick={switchActualUserBack}
                        >
                          Swap Back
                        </MenuItem>
                      </Menu>
                    </AppTooltip>
                  </Box>
                ) : user?.role?.length > 1 ? ( //NOSONAR
                  <Box
                    sx={{
                      px: 1.85,
                    }}
                  >
                    <AppTooltip placement={tooltipPosition}>
                      <IconButton
                        className='icon-btn'
                        sx={{
                          borderRadius: '50%',
                          width: 40,
                          height: 40,
                          color: (theme) => theme.palette.text.secondary,
                          backgroundColor: (theme) =>
                            theme.palette.background.default,
                          border: 1,
                          borderColor: 'transparent',
                          transition: 'transform 0.3s ease-in-out',
                          '&:hover, &:focus': {
                            color: (theme) => theme.palette.text.primary,
                            backgroundColor: (theme) =>
                              alpha(theme.palette.background.default, 0.9),
                            borderColor: (theme) =>
                              alpha(theme.palette.text.secondary, 0.25),
                            transform: 'scale(1.1)',
                          },
                        }}
                        onClick={handleRoleOpenMenu}
                        size='large'
                      >
                        <PublishedWithChangesIcon />
                      </IconButton>

                      <Menu
                        anchorEl={roleAnchorEl}
                        open={Boolean(roleAnchorEl)}
                        onClose={handleRoleCloseMenu}
                      >
                        {user?.role?.map((role) => {
                          return user?.role[0] !== role ? (
                            <MenuItem
                              sx={{ textTransform: 'capitalize' }}
                              key={role}
                              onClick={() => {
                                // Check the condition before calling onSwitchRole

                                switchBack(user.id, role, user.role[0]);
                              }}
                            >
                              <>Swap to {role}</>
                            </MenuItem>
                          ) : null;
                        })}
                      </Menu>
                    </AppTooltip>
                  </Box>
                ) : (
                  ''
                )}
                {user?.id ? (
                  <Box
                    sx={{
                      px: 1.85,
                    }}
                  >
                    <AppNotifications
                      notificationData={notificationData}
                      fetchData={notifications}
                      markAllRead={markAllRead}
                    />
                  </Box>
                ) : (
                  <Box display='flex' alignItems='center'>
                    <IconButton
                      title='Login'
                      className='icon-btn'
                      sx={{
                        borderRadius: '50%',
                        width: 40,
                        height: 40,
                        color: (theme) => theme.palette.text.secondary,
                        backgroundColor: (theme) =>
                          theme.palette.background.default,
                        border: 1,
                        borderColor: 'transparent',
                        transition: 'transform 0.3s ease-in-out',
                        '&:hover, &:focus': {
                          color: (theme) => theme.palette.text.primary,
                          backgroundColor: (theme) =>
                            alpha(theme.palette.background.default, 0.9),
                          borderColor: (theme) =>
                            alpha(theme.palette.text.secondary, 0.25),
                          transform: 'scale(1.1)',
                        },
                      }}
                      onClick={() => navigate('/signin')}
                      size='large'
                    >
                      <PersonOutlined />
                    </IconButton>

                    <IconButton
                      title='Registration'
                      className='icon-btn'
                      sx={{
                        borderRadius: '50%',
                        width: 40,
                        height: 40,
                        color: (theme) => theme.palette.text.secondary,
                        backgroundColor: (theme) =>
                          theme.palette.background.default,
                        border: 1,
                        borderColor: 'transparent',
                        transition: 'transform 0.3s ease-in-out',
                        '&:hover, &:focus': {
                          color: (theme) => theme.palette.text.primary,
                          backgroundColor: (theme) =>
                            alpha(theme.palette.background.default, 0.9),
                          borderColor: (theme) =>
                            alpha(theme.palette.text.secondary, 0.25),
                          transform: 'scale(1.1)',
                        },
                      }}
                      onClick={() => navigate('/signup')}
                      size='large'
                    >
                      <AppRegistrationIcon />
                    </IconButton>
                  </Box>
                )}
                <Box
                  sx={{
                    px: 1.85,
                  }}
                >
                  <AppTooltip title='Cart' placement={tooltipPosition}>
                    <IconButton
                      className='icon-btn'
                      sx={{
                        borderRadius: '50%',
                        width: 40,
                        height: 40,
                        color: (theme) => theme.palette.text.secondary,
                        backgroundColor: (theme) =>
                          theme.palette.background.default,
                        border: 1,
                        borderColor: 'transparent',
                        transition: 'transform 0.3s ease-in-out',
                        '&:hover, &:focus': {
                          color: (theme) => theme.palette.text.primary,
                          backgroundColor: (theme) =>
                            alpha(theme.palette.background.default, 0.9),
                          borderColor: (theme) =>
                            alpha(theme.palette.text.secondary, 0.25),
                          transform: 'scale(1.1)',
                        },
                      }}
                      onClick={() => navigate('/cart')}
                      size='large'
                    >
                      <ShoppingCartOutlinedIcon />
                      <Badge
                        badgeContent={cartData?.length}
                        color='error'
                        sx={{
                          right: -3,
                          top: -16,
                          transition: 'transform 0.3s ease-in-out', // Add a transition effect for scaling
                          transform: 'scale(1)', // Initial scale value
                        }}
                      ></Badge>
                    </IconButton>
                  </AppTooltip>
                </Box>
                <Box
                  sx={{
                    px: 1.85,
                  }}
                >
                  <ServiceDeskWidget
                    tooltipPosition={tooltipPosition}
                    AppTooltip={AppTooltip}
                    isAdmin={isAdmin(user)}
                    isMobile={false}
                    isJSDLoaded={isJSDLoaded}
                  />
                </Box>
                {/* )} */}
                {user?.id ? (
                  <Box
                    sx={{
                      px: 1.85,
                    }}
                  >
                    <AppTooltip title='Logout' placement={tooltipPosition}>
                      <IconButton
                        className='icon-btn'
                        sx={{
                          borderRadius: '50%',
                          width: 40,
                          height: 40,
                          color: (theme) => theme.palette.text.secondary,
                          backgroundColor: (theme) =>
                            theme.palette.background.default,
                          border: 1,
                          borderColor: 'transparent',
                          transition: 'transform 0.3s ease-in-out',
                          '&:hover, &:focus': {
                            color: (theme) => theme.palette.text.primary,
                            backgroundColor: (theme) =>
                              alpha(theme.palette.background.default, 0.9),
                            borderColor: (theme) =>
                              alpha(theme.palette.text.secondary, 0.25),
                            transform: 'scale(1.1)',
                          },
                        }}
                        onClick={logout}
                        size='large'
                      >
                        <PowerSettingsNewIcon />
                      </IconButton>
                    </AppTooltip>
                  </Box>
                ) : (
                  ''
                )}
              </Box>
            </Box>
            {user?.id ? (
              <Box
                sx={{
                  ml: { sm: 2 },
                  mr: { xs: 4, sm: 0 },
                  minWidth: { md: 220 },
                  '& .user-info-view': {
                    p: 0,
                  },
                  '& .user-info': {
                    display: { xs: 'none', md: 'block' },
                  },
                }}
              >
                <UserInfo />
              </Box>
            ) : (
              ''
            )}
            <Box sx={{ display: { xs: "block", sm: "none" } }}>
              <Box
                sx={{
                  position: 'relative',
                  display: 'flex',
                  alignItems: 'center',
                  marginLeft: -2,
                  marginRight: -2,
                }}
              >
                <Box
                  sx={{
                    px: 1.85,
                  }}
                >
                  <AppTooltip title='More'>
                    <IconButton
                      sx={{
                        borderRadius: '50%',
                        width: 40,
                        height: 40,
                        color: (theme) => theme.palette.text.secondary,
                        backgroundColor: (theme) =>
                          theme.palette.background.default,
                        border: 1,
                        borderColor: 'transparent',
                        '&:hover, &:focus': {
                          color: (theme) => theme.palette.text.primary,
                          backgroundColor: (theme) =>
                            alpha(theme.palette.background.default, 0.9),
                          borderColor: (theme) =>
                            alpha(theme.palette.text.secondary, 0.25),
                        },
                      }}
                      onClick={handleClick}
                      size='large'
                    >
                      <MoreVertIcon />
                    </IconButton>
                  </AppTooltip>
                </Box>
              </Box>
            </Box>
            <Menu
              id='simple-menu'
              anchorEl={anchorEl}
              keepMounted
              open={Boolean(anchorEl)}
              onClose={handleClose}
            >
              {!user?.id && (
                <>
                  <MenuItem
                    sx={{ textTransform: 'capitalize' }}
                    onClick={() => {
                      handleClose();
                      navigate('/signin');
                    }}
                  >
                    Login
                  </MenuItem>

                  <MenuItem
                    sx={{ textTransform: 'capitalize' }}
                    onClick={() => {
                      handleClose();
                      navigate('/signup');
                    }}
                  >
                    Registration
                  </MenuItem>
                </>
              )}
              {user?.id && !isMobile && (
                <MenuItem onClick={handleClose}>
                  <AppNotifications
                    notificationData={notificationData}
                    isMenu
                  />
                </MenuItem>
              )}
              {!isMobile && (
                <MenuItem
                  onClick={() => {
                    handleClose();
                    navigate('/cart');
                  }}
                >
                  Cart
                </MenuItem>
              )}
              {user?.actualUser ? (
                <>
                  {user?.selectedUserRoles?.map((role, index) =>
                    user.role[0] !== role.role_name ? (
                      <MenuItem
                        sx={{ textTransform: 'capitalize' }}
                        key={`${role.role_name}_${index}`}
                      >
                        {canSwapTo[user?.actualRole[0]]?.has(role.role_name) ? (
                          <div //NOSONAR
                            onClick={() => {
                              const actualRole =
                                user?.actualRole[0] || user?.role[0];
                              switchBack(
                                user.id,
                                role.role_name,
                                actualRole,
                                user.actualUser,
                                null,
                              );
                            }}
                          >
                            Swap to {role.role_name}
                          </div>
                        ) : (
                          <div
                            className='disable-role'
                            onClick={handleStopClick}
                          >
                            {role.role_name}
                          </div>
                        )}
                      </MenuItem>
                    ) : null,
                  )}
                  {user?.parentuser && (
                    <MenuItem
                      sx={{ textTransform: 'capitalize' }}
                      onClick={() =>
                        switchBack(
                          user.parentuser,
                          'parent',
                          user.actualRole[0],
                          user.actualUser,
                          null,
                        )
                      }
                    >
                      Swap Back to Parent
                    </MenuItem>
                  )}
                  <MenuItem
                    sx={{ textTransform: 'capitalize' }}
                    onClick={switchActualUserBack}
                  >
                    Swap Back
                  </MenuItem>
                </>
              ) : user?.role?.length > 1 ? (
                user?.role?.map((role) => {
                  return user?.role[0] !== role ? (
                    <MenuItem
                      sx={{ textTransform: 'capitalize' }}
                      key={role}
                      onClick={() => {
                        // Check the condition before calling onSwitchRole

                        switchBack(user.id, role, user.role[0]);
                      }}
                    >
                      <>Swap to {role}</>
                    </MenuItem>
                  ) : null;
                })
              ) : null}
              {Boolean(anchorEl) && (
                <ServiceDeskWidget
                  isMobile={true}
                  isAdmin={isAdmin(user)}
                  isJSDLoaded={isJSDLoaded}
                />
              )}
              {user?.id && <MenuItem onClick={logout}>Logout</MenuItem>}
            </Menu>
          </Box>
        </Box>
      </Toolbar>
      <Box sx={{ display: { xs: "block", lg: "none" } }}>
        <HeaderNavWrapper>
          <Box
            className='logo-header'
            sx={{
              boxSizing: 'border-box',
              minHeight: { xs: 56, sm: 70 },
              px: { xs: 0 },
              borderBottom: (theme) => `solid 1px ${theme.palette.divider}`,
            }}
          >
            <Box
              sx={{
                boxSizing: 'border-box',
                width: '100%',
                maxWidth: { lg: 1140, xl: 1436 },
                mx: 'auto',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <Box
                className='main-logo'
                sx={{
                  '& .app-logo': {
                    pl: 0,
                  },
                  '& .logo-text': {
                    display: { xs: 'none', sm: 'block' },
                  },
                }}
              >
                <div className='logo-box'>
                  {companyData?.home_logo_url ? (
                    <img
                      src={`${process.env.NX_CLOUD_FRONT_URL}/${companyData?.home_logo_url}`}
                      alt='success'
                    />
                  ) : (
                    <img
                      src={'/assets/images/membertraxx.png'}
                      alt='success'
                    />
                  )}
                </div>
              </Box>
              <Box
                className='main-navigation'
                sx={{
                  mx: 'auto',
                  display: 'flex',
                  alignItems: 'center',
                  '& .navItemSubmenu.active:before': {
                    backgroundColor: companyTheme
                      ? companyTheme.primary.main
                      : '#2196f3',
                  },
                  '& .navItemSubmenu.active:after': {
                    backgroundColor: companyTheme
                      ? companyTheme.primary.main
                      : '#2196f3',
                  },
                }}
              >
                <HorizontalNav routesConfig={routesConfig} />
              </Box>
            </Box>
          </Box>
        </HeaderNavWrapper>
      </Box>
      {!isMobile && <BreadCrumbUi path={path} companyData={companyData} />}
      <TopMenu path={path} />
    </AppBar>
  );
};
export default AppHeader;

AppHeader.propTypes = {
  toggleNavCollapsed: PropTypes.func,
  routesConfig: PropTypes.array.isRequired,
  tooltipPosition: PropTypes.string,
  fetchDataFunction: PropTypes.func,
  socialSettings: PropTypes.object,
  companyData: PropTypes.object,
};
